export const approvalConstantData = {
    pageType: {
        'view': 'view',
        'edit': 'edit'
    },
    requestType: {
        'health_provider': 'Health provider',
        'health_facility': 'Health Facility',
        'create_facility': 'Create Facility',
        'edit_facility': 'Edit Facility',
        'upgrade_facility': 'Upgrade Facility',
    },
    requestCode: {
    'upgrade_facility': 'UpgradeFacility',
},
    requestFor : {
        sent: 'sent',
        received: 'received'
    }
};

export const pageType={
    previousPage:'Previous Details',
    currentPage:'Current Details'
}
export const approval_filter_list = {
    name: {
        'type': 'textfield',
        'title': 'Name',
        'filter_key': 'name',
        'value': '',
        'isFilterDisable': false,
        'isfilterShow': true,
    },
    dateRange: {
        'type': 'date',
        'title': 'Date Range',
        'filter_key': 'dateRange',
        'value': '',
        'isFilterDisable': false,
        'isfilterShow': true,
    },
    requestType: {
        'type': 'select',
        'title': 'Request Type',
        'filter_key': 'requestType',
        'multiDropdown': false,
        'options': [],
        'value': '',
        'isFilterDisable': false,
        'isfilterShow': true,
    },
    requestStatus: {
        'type': 'select',
        'title': 'Request Status',
        'filter_key': 'requestStatus',
        'multiDropdown': false,
        'options': [],
        'value': '',
        'isFilterDisable': false,
        'isfilterShow': true,
    },
    requests: {
        'type': 'radioButton',
        'title': 'Requests',
        'filter_key': 'requests',
        'required': true,
        'group': 'requests',
        'options': ["Sent", "Received"],
        'value': 'Sent',
        'isFilterDisable': false,
        'isfilterShow': true,
    },
};

export const approvalReceivedListColumnheader = [
    {
        name: 'Requested by',
        key: 'requested_by',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'Request ID',
        key: 'request_serial_id',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'Request Type',
        key: 'request_type',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Health Facility/Health provider',
        key: 'request_for_name',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Date of Request',
        key: 'request_date',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Request Status',
        key: 'request_status',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'ETA',
        key: 'eta',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
];

export const approvalSentListColumnheader = [
    {
        name: 'Action Taken By',
        key: 'status_changed_by',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'Request ID',
        key: 'request_serial_id',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'Request Type',
        key: 'request_type',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Health Facility/Health provider',
        key: 'request_for_name',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Reason',
        key: 'recevier_comment',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Date of Request',
        key: 'request_date',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Request Status',
        key: 'request_status',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'ETA',
        key: 'eta',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
];

export const healtProviderPreviousDataColumnHeader = [
    {
      name: 'HFR ID',
      key: 'hfr_id',
      sortable: true,
    },
    {
      name: 'Health Facility Type',
      key: 'facility_type_name',
      sortable: true,
    },
    {
      name: 'Health Facility Name',
      key: 'facility_name',
      sortable: true,
    },
    {
      name: 'Asha/ Mobiliser Tagged',
      key: 'mobiliser_name',
      sortable: true,
    },
    {
      name: 'Effective From Date',
      key: 'effective_dt',
      sortable: true,
    },
    {
      name: 'Effective To Date',
      key: 'effective_to_dt',
      sortable: true,
    },
  ]

export const STATUS = {
    "PENDING": "Pending",
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "NO_ACTION": "No Action",
}

export const approvalsRoleCode = {
    module_code: "Approvals",
    pageCode: {
        Approvals_Resubmit: 'Approvals_Resubmit',
        Approvals_Reject: 'Approvals_Reject',
        Approvals_EDPg: 'Approvals_EDPg',
        Approvals_LstPg: 'Approvals_LstPg',
        Approvals_Approve: 'Approvals_Approve',
        Approvals_OVPg: 'Approvals_OVPg'
    }
};

export const errorSuccessMessage = {
    statusChangeError: 'Error in status change.',
    approveSuccess: 'Request approved successfully.',
    rejectSuccess: 'Request rejected successfully.',
    reSubmit: 'Request re-submited successfully.',
    rejectStatus: 'Your request was rejected by the approver. You can edit and resubmit the request.',
    noActionStatus: 'No action was taken on your request. You can Re-submit your request to get it approved.',
    checkUserSessionExists: "This user have the upcoming planned session, can't raise shift transfer request."
}

export const roleType = {
    both: 'both',
    only_approver: 'only approver',
    only_administrator: 'only administrator'
};

export const checkUserRole = (roleDetails: any[]) => {
    if (roleDetails.length > 0) {
        if (roleDetails.includes('Approver') && roleDetails.includes('Administrator')) {
            return roleType.both
        } else if(roleDetails.includes('Approver')) {
            return roleType.only_approver
        }  else if(roleDetails.includes('Administrator')) {
            return roleType.only_administrator
        }
    } else {
        return ''
    }
}

export const setStatusMessage = (approvalReqStatus: any, reqefectiveData: any, approvalReqId: any, pageType: any) => {
    return approvalReqStatus == STATUS.APPROVED ? `Although this request ID ${approvalReqId} is approved, the ${pageType == 'facility' ? 'action': 'shift/ transfer'} shall be allowed only after ${reqefectiveData}.` : `Submitted for Approval with Request ID ${approvalReqId}.`;
  }
